
import ruMessages from '../locales/ru-RU';

const RuLang = {
    messages: {
        ...ruMessages
    },
    locale: 'ru-RU',
    
};
export default RuLang;